import React, { useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'src/utils/axios';
import { Skeleton, Box, Alert, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';


const ServiceReportCard = ({ ServiceShopId, TopServiceShopCode }) => {
    const theme = useTheme();
    const [chartData, setChartData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        axios.get(`GetServiceReportCard/${ServiceShopId}`).then((response) => {
            if (response) {
                if (response.data.length > 0) {
                    setChartData(response.data);
                }
            }
            setLoading(false);
        });
    }, [ServiceShopId]);

    const ChartData = {
        series: [{
            name: 'Servis Puanı',
            type: 'column',
            data: chartData?.map((item) => ({
                x: item.Period,
                y: item.ServicePoint.toFixed(1),
                HarfNotu: item.ServiceLetterGrade
            }))
        }, {
            name: 'Türkiye Sırası',
            type: 'line',
            data: chartData?.map((item) => ({
                x: item.Period,
                y: item.ServiceRank
            }))
        }],
        options: {
            chart: {
                type: 'line',
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                },
                events: {
                    dataPointSelection: function (event, chartContext, config) {
                        // open new tab with the selected period
                        window.open(`http://arreportsql/ReportServer/Pages/ReportViewer.aspx?%2fTHRaporlar%2fGenel%2fKarneV2&rs:Command=Render&KARNE_DONEMI=${chartData[config.dataPointIndex].Month}&YIL=${chartData[config.dataPointIndex].Year}&UBR=${TopServiceShopCode}&BIRIM_KODU=${ServiceShopId}
`, '_blank');



                    }
                }
            },
            stroke: {
                width: [0, 4]
            },
            title: {
                text: 'Karne Sonuçları'
            },
            dataLabels: {
                enabled: true,
                enabledOnSeries: [0],
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    if (seriesIndex === 0) {
                        return 'Harf Notu: ' + w.config.series[seriesIndex].data[dataPointIndex].HarfNotu;
                    }
                },
                style: {
                    colors: ['#000000'],
                    fontSize: '10px',

                }
            },
            labels: chartData.map((item) => item.Period),
            yaxis: [{
                title: {
                    text: 'Servis Puanı',
                },
            }, {
                opposite: true,
                reversed: true,
                title: {
                    text: 'Türkiye Sırası'
                },
                labels: {
                    formatter: function (value) {
                        return Math.floor(value);
                    }
                },
                min: 1,
            }],
        },
    };

    return (
        <Box>
            {loading ? (
                <Skeleton variant="rectangular" width="100%" height={350} />
            ) : (
                <Grid container spacing={1}>

                    <Grid size={12}>
                        <ReactApexChart options={ChartData.options} series={ChartData.series} type="line" height={350} />
                    </Grid>
                    <Grid size={12}>
                        <Alert
                            variant="outlined"
                            severity="info"
                            sx={{
                                borderColor: theme.palette.info.dark,
                                fontSize: '12px',
                                fontFamily: 'Helvetica, Arial, sans-serif'
                            }}>
                            Son 5 yıla ait Kasım karneleri, mevcut yılın Mart karnesi ve en son yayınlanan karneden bir önceki karne sonuçlarını gösterir.
                        </Alert>
                    </Grid>


                </Grid>
            )}
        </Box>
    );
};

export default ServiceReportCard;
